
import { useContext } from 'react';
import { FilterContext } from '../contexts/filter';

export function useFitler() {
  return useContext(FilterContext);
}

